import { useOutletContext } from "react-router-dom";
import { ContextType } from "src/router/PrivateRoutes";

export function usePaddingWrapper() {
    return useOutletContext<ContextType>();
}